import React, { useEffect, useState } from "react";
import axios from "axios";
import { useSiteSettings } from "../../context/SiteSettingsContext";

const DocumentationSettings: React.FC = () => {
    const { settings: siteSettings } = useSiteSettings();
    const clientOptions = [
      { label: "Klient/ in", value: "client" },
      { label: "Patient/ in", value: "patient" },
      { label: "Kunde/ Kundin", value: "customer" }
    ];
    const therapistOptions = [
      { label: "Psychologe/ Psychologin", value: "psychologist" },
      { label: "Therapeut/ in", value: "therapist" },
      { label: "Psychotherapeut/ in", value: "psychotherapist" },
      { label: "Berater/ in", value: "counselor" },
      { label: "Arzt/ Ärztin", value: "doctor" }
    ];
    const therapyOptions = [
      { label: "Verhaltenstherapie (VT)", value: "vt" },
      { label: "Systemische Therapie (ST)", value: "st" },
      { label: "Tiefenpsychologisch fundierte Psychotherapie (TP)", value: "tp" },
      { label: "Allgemeine Therapie/Beratung (Allg.)", value: "at" }
    ];
    const [selectedClient, setSelectedClient] = useState("");
    const [selectedTherapist, setSelectedTherapist] = useState("");
    const [selectedTherapy, setSelectedTherapy] = useState("");
    const [isKjp, setIsKjp] = useState(false);
    const [multiDocumentationEnabled, setMultiDocumentationEnabled] = useState(false);
    const [initialValues, setInitialValues] = useState({ client_label: "", provider_label: "", therapy_form: "", is_kjp: false, multi_documentation_enabled: false });
    const [isDirty, setIsDirty] = useState(false);

  useEffect(() => {
    axios.get("/api/apps/note-settings")
        .then((res) => {
            setSelectedClient(res.data.client_label);
            setSelectedTherapist(res.data.provider_label);
            setSelectedTherapy(res.data.therapy_form || "");
            setIsKjp(!!res.data.is_kjp);
            setMultiDocumentationEnabled(!!res.data.multi_documentation_enabled);
            setInitialValues({
                client_label: res.data.client_label,
                provider_label: res.data.provider_label,
                therapy_form: res.data.therapy_form || "",
                is_kjp: !!res.data.is_kjp,
                multi_documentation_enabled: !!res.data.multi_documentation_enabled
            });
        })
        .catch((error) => {
            console.error("Failed to load note settings:", error);
            // Optional: Fallback-Werte setzen
            setSelectedClient("client");
            setSelectedTherapist("therapist");
        });
}, []);

    return (
        <div className="w-full h-[calc(100vh-10rem)] pt-4 lg:pt-8 pb-24 sm:pb-0 overflow-y-auto overflow-x-hidden px-4">
            <div className="w-full max-w-6xl pb-6">
                <header className="tw-flex tw-items-center tw-justify-between tw-mb-5">
                    <div className="tw-space-y-3">
                        <h3 className="tw-font-bold tw-text-2xl tw-text-black">Globale Dokumentationseinstellungen</h3>
                        <p className="tw-text-gray-500">Alle Auswahlmöglichkeiten hier helfen der KI, die Dokumentation an Ihre Bedürfnisse anzupassen</p>
                    </div>
                    <div className="tw-bg-white  tw-w-full  md:tw-w-auto  tw-fixed tw-bottom-0 tw-left-0 tw-px-3 tw-py-4 tw-flex tw-items-center tw-justify-end md:tw-p-0  md:tw-bg-transparent  md:tw-static tw-z-10 ">
                        <button
                            className="_button_19rto_40 _purple_19rto_126 _filled_19rto_80 tw-px-9 tw-w-full md:tw-w-auto"
                            disabled={!isDirty}
                            onClick={() => {
                                const payload: Record<string, unknown> = {
                                    client_label: selectedClient,
                                    provider_label: selectedTherapist,
                                    therapy_form: selectedTherapy
                                };
                                payload.is_kjp = isKjp;
                                if (siteSettings?.multi_documentation_available) {
                                    payload.multi_documentation_enabled = multiDocumentationEnabled;
                                }
                                axios.put("/api/apps/note-settings/", payload).then(() => setIsDirty(false));
                            }}
                        >
                            <div className="_btnFlex_19rto_32">Speichern</div>
                        </button>
                    </div>
                </header>



                <main>

                    <section className="tw-mt-8 tw-mb-4">
                      <div className=" tw-flex tw-items-center tw-gap-3">
                        <span className=" tw-font-semibold tw-text-[14px]"> Zielgruppe </span>
                      </div>
                      <div className="w-100 tw-space-x-3">
                        <div className="!tw-m-0 tw-flex tw-flex-wrap tw-items-start tw-gap-x-3 tw-gap-y-5 tw-w-full">
                          {[
                            { value: "adult", label: "Erwachsene (PP, ÄP)", kjp: false },
                            { value: "kjp", label: "Kinder & Jugendliche (KJP)", kjp: true },
                          ].map((option) => (
                            <div key={option.value} className="tw-flex tw-items-center tw-gap-2 tw-flex-1 tw-mr-5 md:tw-mr-10 tw-py-2">
                              <input
                                type="radio"
                                id={`kjp-target-${option.value}`}
                                name="kjp-target"
                                className="lumanoteEX__radio tw-cursor-pointer"
                                checked={isKjp === option.kjp}
                                onChange={() => {
                                  setIsKjp(option.kjp);
                                  setIsDirty(true);
                                }}
                              />
                              <label
                                htmlFor={`kjp-target-${option.value}`}
                                className={`radio__group__each__label ${isKjp === option.kjp ? "!tw-text-black" : "!tw-text-gray"}`}
                              >
                                {option.label}
                              </label>
                            </div>
                          ))}
                        </div>
                      </div>
                    </section>

                    <section className="tw-mt-8 tw-mb-4">
                      <div className=" tw-flex tw-items-center tw-gap-3">
                        <span className=" tw-font-semibold tw-text-[14px]"> Therapieform </span>
                      </div>
                      <div className="w-100 tw-space-x-3">
                        <div className="!tw-m-0 tw-flex tw-flex-wrap tw-items-start tw-gap-x-3 tw-gap-y-5 tw-w-full">
                          {therapyOptions.map((option) => (
                            <div key={option.value} className="tw-flex tw-items-center tw-gap-2 tw-flex-1 tw-mr-5 md:tw-mr-10 tw-py-2">
                              <input
                                type="radio"
                                id={option.value}
                                name="therapyOptions"
                                className="lumanoteEX__radio tw-cursor-pointer"
                                value={option.value}
                                checked={selectedTherapy === option.value}
                                onChange={() => {
                                  setSelectedTherapy(option.value);
                                  setIsDirty(true);
                                }}
                              />
                              <label htmlFor={option.value} className={`radio__group__each__label ${selectedTherapy === option.value ? "!tw-text-black" : "!tw-text-gray"}`}>
                                {option.label}
                              </label>
                            </div>
                          ))}
                        </div>
                      </div>
                    </section>

                    
                    <div className="tw-space-y-3">
                        <div className=" tw-flex tw-items-center tw-gap-3">
                            <span className=" tw-font-semibold tw-text-[14px]"> Terminologie </span>

                        </div>

                        <div className="w-100 tw-space-x-3">
                            <span className=" tw-text-black !tw-font-normal tw-mb-3 tw-block">Person, die die Dienstleistung(en) erhält</span>
                            <div className=" !tw-m-0 tw-flex tw-flex-wrap tw-items-start tw-gap-x-3 tw-gap-y-5 tw-w-full">
                                {clientOptions.map((option) => (
                                    <div key={option.value} className="tw-flex tw-items-center tw-gap-2  tw-flex-1  tw-mr-5 md:tw-mr-10 tw-py-2">
                                        <input
                                            type="radio"
                                            id={option.value}
                                            name="clientOptions"
                                            className="lumanoteEX__radio tw-cursor-pointer"
                                            value={option.value}
                                            checked={selectedClient === option.value}
                                            onChange={() => {
                                                setSelectedClient(option.value);
                                                setIsDirty(true);
                                            }}
                                        />
                                        <label htmlFor={option.value} className={`radio__group__each__label ${selectedClient === option.value ? "!tw-text-black" : "!tw-text-gray"}`}>
                                            {option.label}
                                        </label>
                                    </div>
                                ))}
                            </div>
                        </div>

                        <div className="w-100 tw-space-x-3">
                            <span className=" tw-text-black !tw-font-normal tw-mb-3 tw-block">Person, die die Dienstleistung(en) erbringt</span>
                            <div className=" !tw-m-0 tw-flex tw-flex-wrap tw-items-start tw-gap-x-3 tw-gap-y-5 tw-w-full">
                                {therapistOptions.map((option) => (
                                    <div key={option.value} className="tw-flex tw-items-center tw-gap-2  tw-flex-1  tw-mr-5 md:tw-mr-10 tw-py-2">
                                        <input
                                            type="radio"
                                            id={option.value}
                                            name="therapistOptions"
                                            className="lumanoteEX__radio tw-cursor-pointer"
                                            value={option.value}
                                            checked={selectedTherapist === option.value}
                                            onChange={() => {
                                                setSelectedTherapist(option.value);
                                                setIsDirty(true);
                                            }}
                                        />
                                        <label htmlFor={option.value} className={`radio__group__each__label ${selectedTherapist === option.value ? "!tw-text-black" : "!tw-text-gray"}`}>
                                            {option.label}
                                        </label>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>

                    {siteSettings?.multi_documentation_available && (
                        <section className="tw-mt-8 tw-mb-4">
                            <div className=" tw-flex tw-items-center tw-gap-3">
                                <span className=" tw-font-semibold tw-text-[14px]"> Arbeitsweise </span>
                            </div>
                            <div className="w-100 tw-space-x-3">
                                <div className="!tw-m-0 tw-flex tw-items-start tw-gap-3 tw-w-full tw-py-2">
                                    <input
                                        type="checkbox"
                                        id="multi-documentation-enabled"
                                        className="tw-cursor-pointer tw-mt-1"
                                        checked={multiDocumentationEnabled}
                                        onChange={(event) => {
                                            setMultiDocumentationEnabled(event.target.checked);
                                            setIsDirty(true);
                                        }}
                                    />
                                    <label htmlFor="multi-documentation-enabled" className="tw-flex tw-flex-col tw-gap-1 tw-cursor-pointer">
                                        <span className="radio__group__each__label !tw-text-black">
                                            Mehrere Dokumentationen parallel bearbeiten
                                        </span>
                                        <span className="tw-text-gray-500 tw-text-sm">
                                            Pro Sitzung können mehrere Dokumentationen erstellt und parallel in Reitern bearbeitet werden.
                                        </span>
                                    </label>
                                </div>
                            </div>
                        </section>
                    )}

                    

                   

                    
                </main>
            </div>
        </div>
    );
};

export default DocumentationSettings;
